/* Copyright (c) 2023 GRIP.S Medien GmbH & Co.KG */

import Swagger from 'swagger-client';

class Api {
  constructor(apiOptions = {}) {
    const options = apiOptions || {};
    const baseApi =
      process.env.NODE_ENV === 'development'
        ? 'http://localhost:8080'
        : process.env.PUBLIC_URL;

    this.state = {
      api: `${baseApi}${options.api}`,
      token: options.token || '',
      hasLoaded: false,
      scopes: [],
    };
  }

  init = async (forced) => {
    if (!this.state.hasLoaded || forced) {
      return this.load();
    }
  };

  load = async () => {
    try {
      // this.state.token = Caba.getToken();
      this.swagger = null;
      this.apis = null;

      const client = await Swagger({
        url: `${this.state.api}/swagger.json`,
        requestInterceptor: (req) => {
          /* eslint no-param-reassign: "error" */
          if (this.state.token) {
            req.headers.Authorization = `Bearer ${this.state.token}`;
          }
          return req;
        },
      });

      if (client.errors.length) console.error(client.errors);

      this.swagger = client;
      this.apis = client.apis;
      this.spec = client.spec;
      this.hasLoaded = true;

      // console.info('Api', client.apis);

      // window.api = client;

      return client;
    } catch (error) {
      console.error('failed to load swagger definition', error);
      throw error;
    }
  };

  isReady = () => this.state.hasLoaded;

  getToken = () => this.state.token;

  setToken = (token) => (this.state.token = token);

  getScopes = () => this.state.scopes;

  setScopes = (scopes) => (this.state.scopes = scopes);

  getUser = () => this.state.user;

  setUser = (user) => {
    this.state.user = user;
    this.setScopes(user.scopes);
  };
}

export default Api;
